import { put, select, takeEvery } from 'redux-saga/effects'
import { UserConstants } from '../../user/store/user.constants'
import { getCrewListSelector } from '../selectors'
import { setCrewList } from '../store/crew.actions'
import { CrewConstants } from '../store/crew.constants'
import { ICrewMemberList } from '../store/crew.types'

export function* checkCrewList() {
  const crewList: ICrewMemberList = yield select(getCrewListSelector)

  if (crewList && crewList.length > CrewConstants.MIN_NO_OF_CREW_MEMBERS_DEL) {
    const newCrewList = crewList.filter((crew) => crew.roleId.length || crew.userId !== null)
    yield put(setCrewList(newCrewList))
  }
}

export function* checkCrewListSaga() {
  yield takeEvery([UserConstants.SET_SERVICE, CrewConstants.CHECK_CREW_LIST], checkCrewList)
}
